import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ListCountries, ZoneElement } from '../models/zone.model';
import { ZoneService } from '../services/zone.service';
import { MenusComponent } from './../menus/menus.component';
import { CompanyService } from './../services/company.service';
import { MatPaginator } from '@angular/material/paginator';
import { ListCompanies } from '../models/company.model';
import { StorageService } from '../services/storage.service';

const lstZones: ZoneElement[] = [];

@Component({
  selector: 'app-zones',
  templateUrl: './zones.component.html',
  styleUrl: './zones.component.css'
})

export class ZonesComponent implements OnInit  {

  private rowClick$  = new Subject<ZoneElement>();

  displayedColumns: string[] = ['id', 'zone_name', 'zone_company', 'zone_country', 'zone_description'];
  displayedColumnsCompany: string[] = ['id', 'zone_name', 'zone_country', 'zone_description'];

  displayedColumns2: string[] = ['id', 'zone_name', 'company_id'];

  @ViewChild(MatPaginator) paginator!: MatPaginator;

  dataSource = new MatTableDataSource<ZoneElement>(lstZones);


  constructor(private router: Router, private zoneService: ZoneService,
              private menusComponent: MenusComponent, private companyService: CompanyService,
              public storageService: StorageService) { }

  isLoading = false;
  @ViewChild(MatSort)
  sort: MatSort = new MatSort;
  public superAdm = false;
  
  lstCompanies: ListCompanies[]=[];
  items: any = [];
  lstCountries: ListCountries[] = [];

  ngAfterViewInit() {
    this.dataSource.sort = this.sort;
    this.paginator._intl.itemsPerPageLabel="Registros por página";
    this.dataSource.paginator = this.paginator;
  }

  ngOnInit(): void {
    this.rowClick$.subscribe(
      row => console.log('[row clicked]', row)
    );
    this.isLoading = true;
    if(this.storageService.roleId==2){
      this.displayedColumns=this.displayedColumnsCompany
    }
    this.lstCompanies=this.companyService.getCompaniesListByRol(this.storageService.roleId,
                                                                this.storageService.companyId);
    this.lstCountries = this.zoneService.getCountries();
    this.loadZones();
    this.isLoading = false;
  }

  loadZones():void {
    const req=this.zoneService.getAllZones(this.storageService.companyId);
    req.subscribe({
      next: (res) => {
        this.items = res;
        this.dataSource.data=this.items.data;
      },
      error: (e) => {
        console.error(e);
        let msg = e.error.message;
      },
    });
  }

  onRowClicked(row: ZoneElement): void {
    this.rowClick$.next(row);
    this.router.navigate(['zone'], { queryParams: { id: row.id } });
  }

  getCompanyName(companyId: number): string {
    const company = this.lstCompanies.find(comp => comp.value === companyId);
    return company ? company.viewValue : 'Unknown';
  }

  getContryNameByID(countryId:string): string {
    if (!countryId || countryId.trim() === "") return '';
    const countryName = this.lstCountries.find(v => v.value.toLowerCase() === countryId.toLowerCase());
    return countryName ? countryName.viewValue : '';
  }
}
